import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_BASE_URL;

// --- ASYNC THUNKS ---

export const fetchImportHistory = createAsyncThunk(
  'employeeImport/fetchHistory',
  async (params = {}, { rejectWithValue }) => {
    try {
      const { limit = 200, skip = 0 } = params;
      const response = await axios.get(`${API_URL}/import-logs`, { params: { limit, skip } });
      return response.data; 
    } catch (err) {
      return rejectWithValue(err.response?.data || 'Failed to fetch history');
    }
  }
);

export const fetchBatchDetails = createAsyncThunk(
  'employeeImport/fetchDetails',
  async (batchId, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_URL}/import-logs/${batchId}/details`);
      // This returns the { header, items } object from your Swagger
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || 'Failed to fetch details');
    }
  }
);

// --- THE SLICE ---

const employeeImportSlice = createSlice({
  name: 'employeeImport',
  initialState: {
    history: [],
    totalCount: 0,
    historyLoading: false,
    selectedBatchDetails: [], 
    detailsLoading: false,
    error: null,
  },
  reducers: {
    clearDetails: (state) => { 
      state.selectedBatchDetails = []; 
    }
  },
  extraReducers: (builder) => {
    builder
      /* Fetch Import History */
      .addCase(fetchImportHistory.pending, (state) => { 
        state.historyLoading = true; 
        state.error = null;
      })
      .addCase(fetchImportHistory.fulfilled, (state, action) => {
        state.historyLoading = false;
        // Adjusting based on common API patterns:
        state.history = action.payload?.data || (Array.isArray(action.payload) ? action.payload : []);
        state.totalCount = action.payload?.total || state.history.length || 0;
      })
      .addCase(fetchImportHistory.rejected, (state, action) => { 
        state.historyLoading = false;
        state.error = action.payload;
      })

      /* Fetch Batch Details */
      .addCase(fetchBatchDetails.pending, (state) => { 
        state.detailsLoading = true; 
        state.error = null;
      })
      .addCase(fetchBatchDetails.fulfilled, (state, action) => {
        state.detailsLoading = false;
        /**
         * CORRECTION: Based on your Swagger response:
         * action.payload is { header: {...}, items: [...] }
         * We need the "items" array.
         */
        state.selectedBatchDetails = action.payload?.items || [];
      })
      .addCase(fetchBatchDetails.rejected, (state, action) => { 
        state.detailsLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearDetails } = employeeImportSlice.actions;
export default employeeImportSlice.reducer;